import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_KEY_CLASSROOM_HOME_USE_SETTING = gql`
  mutation updateKeyClassroomSettingHomeUse($data: UpdateKeyClassroomSettingHomeUseInput!) {
    updateKeyClassroomSettingHomeUse(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_CLASSROOM_HOME_USE_SETTING;
